var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_vm._m(0),_c('div',{staticClass:"wrapper"},[_c('Address',{ref:"addressForm",attrs:{"address":_vm.address},on:{"submitting":function($event){_vm.submitting=true}}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"image-holder",attrs:{"alt":"Vue logo","src":require("../assets/fuldmagt.jpg")}})])
}]

export { render, staticRenderFns }